import SimpleBar from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";

export default SimpleBar;
